"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'Icon require that you use the <code class="inline">name</code> ' +
    'property.';
var code = "import React from 'react';\nimport { Icon } from 'jsc-react-ui';\n\nconst Example = () => <Icon name=\"plus\" />;";
exports.SimpleExampleIcon = function () { return (React.createElement(common_1.Example, { title: "Simple", description: description, code: code },
    React.createElement(components_1.Icon, { name: "plus" }))); };
exports.SimpleExampleIcon.displayName = 'SimpleExampleIcon';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconPage/SimpleExampleIcon.tsx
// module id = 684
// module chunks = 0